module.exports = __webpack_public_path__ + "static/media/pin.8d0f8a51.svg";